import React from 'react';
import { Typography } from '@mui/material';

interface PayerTemplateProps {
  payerName?: string | null;
}

/**
 * Displays payer name.
 */
export const PayerTemplate: React.FC<PayerTemplateProps> = ({ payerName }) => (
  <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
    {payerName || '-'}
  </Typography>
);

/** Syncfusion grid template wrapper */
export const payerTemplate = (props: { payerName?: string | null }) => (
  <PayerTemplate payerName={props.payerName} />
);

export default PayerTemplate;
